module.exports = __webpack_public_path__ + "img/12_44.b40b9327.png";